module.exports = __webpack_public_path__ + "static/media/Artboard15.f6f5f2a0.png";